<template>
  <div style="height:100%" class="file_upload">
    <el-upload v-if="showUpload" multiple style="height:260px" class="upload-demo" ref="upload"
      action="https://jsonplaceholder.typicode.com/posts/" :http-request="uploadFile" :on-preview="handlePreview"
      :before-upload="beforeUpload" :on-remove="handleRemove" :on-error="handleError" :file-list="fileList"
      :auto-upload="false">
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      <div slot="tip" class="el-upload__tip">上传文件不能超过200M</div>
    </el-upload>
    <el-card class="mt-2" :body-style="{ padding: '0' }">
      <div slot="header" class="clearfix">
        <span>附件列表</span>
        <el-button v-if="showUpload" @click="handleDelete" class="ml-2" icon="iconfont icon-delete" type="danger" plain
          size="mini"> 删除
        </el-button>
        <el-button @click="handleDownload" class="ml-2" icon="iconfont icon-download" type="primary" plain size="mini">下载
        </el-button>
      </div>
      <el-table size="mini" :data="tableData" stripe style="width: 100%;"
        :height="showUpload ? 'calc(100vh - 550px)' : 'calc(100vh - 290px)'" border
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column v-for="(item, index) in fields1" :key="index" :prop="item.key" :label="item.label"
          :width="item.width">
        </el-table-column>
        <el-table-column v-if="showUpload" fixed="right" label="操作" width="60">
          <template slot-scope="data">
            <el-button @click="handleEdit(data.row)" type="text" size="small">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

  </div>
</template>
<script>
import numbro from "numbro";
import * as FileUploadController from "../controllers/FileUploadController";
export default {
  props: {
    accessoryCategory: { type: String, default: "" },
    showUpload: { type: Boolean, default: true },
    isGuest: { type: Boolean, default: false },
  },
  components: {},
  data() {
    return {
      accessoryCode: "",
      query_lable: this.$t("common.query"),
      isBusy: false,
      fields1: _.cloneDeep(FileUploadController.fields.default),
      fileList: [],
      tableData: [],
      tableDataHis: [],
      uploadResaultData: [],
      multipleSelection: [],
      loading: null
    };
  },
  created() {
    this.fields1 = _.filter(this.fields1, (t) => {
      if (!t.thStyle || (t.thStyle && !t.thStyle.display)) {
        if (!this.showUpload) {
          if (t.key != "uploadBy" && t.key != "uploadAt") return t;
        }
        else return t;
      }
    })
  },
  methods: {
    getAccessory(accessoryJson, code) {
      this.accessoryCode = code;
      this.tableData = [];
      this.fileList = [];
      this.tableDataHis = [];
      if (accessoryJson && accessoryJson != "") {
        let dt = JSON.parse(accessoryJson);
        this.tableDataHis = _.cloneDeep(dt);
        _.each(dt, (t) => {
          if (typeof (t.size) != "string")
            t["size_format"] = numbro(_.round(t.size / 1024)).format({ thousandSeparated: true });
        })
        this.tableData = dt;
      }
    },
    async submitUpload() {
      let error_files = [], error_filename_list = [];
      _.each(this.$refs.upload.uploadFiles, (t) => {
        if (t.size > 200 * 1024 * 1024) {
          error_files.push(t.name)
        }
        else if (t.name.indexOf('/') > -1 ||
          t.name.indexOf('&') > -1 ||
          t.name.indexOf('+') > -1 ||
          t.name.indexOf('#') > -1 ||
          t.name.indexOf('%') > -1 ||
          t.name.indexOf('=') > -1) {
          error_filename_list.push(t.name)
        }
      })
      if (error_files.length > 0) {
        this.msgToasts(_.join(error_files, "，") + "，超过200M不能上传！", "info");
        return
      }
      else if (error_filename_list.length > 0) {
        this.msgToasts("文件名不能包含特殊符号（'/','&','+','#','%','='）！", "info");
        return
      }
      if (this.$refs.upload.uploadFiles.length > 0) {
        this.loading = this.$loading({
          lock: true,
          text: "文件上传中，请稍后...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
        this.$refs.upload.submit();
      }
    },
    async uploadFile(data) {
      console.log(data)
      let p = { category: this.accessoryCategory, code: this.accessoryCode, files: data.file }
      let frt = await FileUploadController.methods.uploadToAzure(p);
      if (frt && frt.length > 0) {
        let lt = [];
        frt[0].description = ""
        lt.push(frt[0])
        let dt = _.union(this.tableDataHis, lt);
        this.getAccessory(JSON.stringify(dt), this.accessoryCode);
        this.$emit("setAccessory", JSON.stringify(this.tableDataHis));
      }
      this.loading.close()
    },

    async handleDelete() {
      let is_continue = await this.checkFileDeleteState();
      if (is_continue) return;

      if (this.multipleSelection == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        return
      }
      let ask = await this.$confirm(this.$t("notify.is_continue"), "提示").then(t => { return true; }).catch(t => { return false });
      if (!ask) return;
      this.loading = this.$loading({
        lock: true,
        text: "文件删除中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      for (var i in this.multipleSelection) {
        let t = this.multipleSelection[i];
        let p = { category: t.category, code: t.code, idx: t.idx, fileName: t.fileName };
        await FileUploadController.methods.deleteFromAzure(p);
      }
      this.tableData = _.differenceWith(this.tableData, this.multipleSelection, _.isEqual);
      let del_dt = []
      _.each(this.tableData, (data) => {
        let hm = _.find(this.tableDataHis, (t) => { return t.idx === data.idx })
        if (hm) del_dt.push(hm)
      })
      this.getAccessory(JSON.stringify(del_dt), this.accessoryCode);
      this.$emit("setAccessory", JSON.stringify(del_dt));
      this.loading.close()
      this.msgToasts(this.$t("notify.action_successfully"), "success");
    },
    async handleEdit(data) {
      let is_continue = await this.checkFileDeleteState();
      if (is_continue) return;
      let rm = await this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: data.description
      }).then(({ value }) => {
        return { state: true, val: value }
      }).catch(() => {
        return { state: false }
      });
      if (!rm.state) {
        return;
      }
      this.loading = this.$loading({
        lock: true,
        text: "文件保存中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      data.description = rm.val;
      let m = { idx: data.idx, description: data.description };
      await FileUploadController.methods.updateDescription(m);
      this.$forceUpdate();
      let hm = _.find(this.tableDataHis, (t) => { return t.idx === data.idx })
      if (hm) {
        hm.description = data.description;
        this.$emit("setAccessory", JSON.stringify(this.tableDataHis));
      }
      this.loading.close()
      this.msgToasts(this.$t("notify.action_successfully"), "success");
    },
    async handleDownload() {
      let is_continue = await this.checkFileDeleteState();
      if (is_continue) return;
      if (this.multipleSelection == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info");
        return
      }
      this.loading = this.$loading({
        lock: true,
        text: "文件下载中，请稍后...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
        customClass: "fileUploadStyle"
      });
      for (var i in this.multipleSelection) {
        let t = _.cloneDeep(this.multipleSelection[i]);
        // console.log(t)
        // t["_fileName"] = t.fileName
        // t.fileName = encodeURIComponent(t.fileName)
        // console.log(t.fileName)
        await FileUploadController.methods.downLoadFromAzure(t);
      }
      this.loading.close();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    ///检查文件删除状态
    async checkFileDeleteState() {
      if (this.isGuest) return false

      if (this.tableDataHis.length == 0)
        return false;
      let real_dt = [], deleted_dt = [];
      let crt = await FileUploadController.methods.getFileDeleteState(_.map(this.tableDataHis, (t) => {
        return { idx: t.idx, category: t.category, code: t.code }
      }));
      if (crt) {
        _.each(crt, (t) => {
          let m = _.find(this.tableDataHis, { idx: t[0].idx, category: t[0].category, code: t[0].code })
          if (t[0] && t[0].is_deleted === 0)
            real_dt.push(m);
          else
            deleted_dt.push(m.fileName);
        })
      }
      if (deleted_dt.length > 0) {
        let ask = await this.$confirm(_.join(deleted_dt, ",") + "文件已删除，无法正常执行相关操作！是否立即更新？", "提示").then(t => { return true; }).catch(t => { return false });
        if (ask) {
          this.getAccessory(JSON.stringify(real_dt), this.accessoryCode);
          this.$emit("setAccessory", JSON.stringify(real_dt));
        }
        return true;
      }
      console.log(real_dt)
      return false;
    },
    //#region 其他
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleError(err, file, fileList) {
      console.log(err, file, fileList);
    },

    handlePreview(file) {
      console.log(file);
    },
    async beforeUpload(file) {
      if (this.isGuest) return true
      let is_continue = await this.checkFileDeleteState();
      return !is_continue;
    },
    //#endregion
  }
}
</script>
<style>
.file_upload {}

.file_upload .el-upload-list {
  height: 200px;
  overflow: auto;
  border: solid 1px #80808042;
}

.fileUploadStyle {
  font-size: 20px;
}
</style>
